<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Add New Transfer Asset">
        <b-form @submit.prevent="submitNewTransfer">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Request To Branch *"
                label-for="branch"
              >
                <v-select
                  v-model="chosenBranch"
                  :options="branches"
                  placeholder="Select Branch"
                  @input="onBranchChange"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Document *"
                label-for="file"
              >
                <b-form-file
                  id="file"
                  placeholder="Choose file..."
                  @change="handleFilesUpload"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Notes"
                label-for="notes"
              >
                <b-form-input
                  id="notes"
                  v-model="transferNotes"
                  placeholder="Enter transfer notes..."
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="mt-2"
            >
              <b-form-group
                label="Search & Add Items *"
                label-for="chosenItem"
              >
                <Select2
                  v-model="chosenItem"
                  :settings="select2Settings"
                  :disabled="!chosenBranch"
                  @select="putItem($event)"
                />
                <small
                  v-if="!chosenBranch"
                  class="text-danger"
                >
                  Please select a branch first to load items.
                </small>
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="mt-3"
            >
              <b-row class="pb-2 border-bottom font-weight-bold text-center">
                <b-col cols="6">
                  Item Name
                </b-col>
                <b-col cols="3">
                  Qty
                </b-col>
                <b-col cols="3">
                  Actions
                </b-col>
              </b-row>

              <div
                v-if="chosens.length > 0"
                class="mt-2"
              >
                <b-row
                  v-for="(item, index) in chosens"
                  :key="index"
                  class="align-items-center py-1 border-bottom"
                >
                  <b-col cols="6">
                    <span class="d-block p-2 bg-light rounded text-truncate">
                      {{ item.label }}
                    </span>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      v-model="item.qty"
                      type="number"
                      min="1"
                      required
                    />
                  </b-col>
                  <b-col
                    cols="3"
                    class="text-center"
                  >
                    <b-button
                      variant="flat-danger"
                      size="sm"
                      @click="removeRow(item.value)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <div
                v-else
                class="text-center py-4 text-muted"
              >
                No items added yet.
              </div>
            </b-col>

            <b-col
              cols="12"
              class="text-right mt-3"
            >
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                :disabled="chosens.length === 0"
              >
                Submit Transfer
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormFile,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Select2 from 'v-select2-component'
import axios from 'axios'
import moment from 'moment-timezone'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormFile,
    vSelect,
    Select2,
  },
  data() {
    return {
      chosenBranch: null,
      branches: [],
      chosenItem: null,
      chosens: [],
      transferNotes: '',
      file: null,
      select2Settings: {
        placeholder: 'Search for assets...',
        ajax: {
          url: process.env.VUE_APP_API_URL
          ? `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ASSET_ITEMS}`
          : '/api/fallback-error',
          dataType: 'json',
          delay: 250,
          headers: {
            Authorization: `Bearer ${this.$cookies.get('userToken')}`,
          },
          data: params => ({
            search: params.term,
            branch_id: this.chosenBranch ? this.chosenBranch.value : null,
            type: 'Asset',
            limit: 10,
          }),
          processResults: response => ({
            results: response.data.map(item => ({
              id: item.asset_id,
              text: `${item.asset_number} - ${item.item.item_name}`,
              value: item.asset_id,
            })),
          }),
        },
      },
    }
  },
  watch: {
    chosenBranch: {
      handler(newVal) {
        if (newVal && newVal.value) {
          // Update the setting directly
          this.select2Settings.ajax.url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ASSET_ITEMS}`
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getBranches()
  },
  methods: {
    onBranchChange() {
      this.chosens = []
      if (this.chosenBranch) {
        this.select2Settings.ajax.url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ASSET_ITEMS}?branch_id=${this.chosenBranch.value}`
      }
    },
    getBranches() {
      const headers = { Authorization: `Bearer ${this.$cookies.get('userToken')}` }
      axios.get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_BRANCHES}?all=true`, { headers })
        .then(res => {
          this.branches = res.data.data.map(b => ({
            label: `${b.branch_name} (${b.branch_code})`,
            value: b.branch_id,
          }))
        })
        .catch(err => this.showToast('Error', err.message, 'danger'))
    },
    putItem(item) {
      const exists = this.chosens.find(x => x.value === item.id)
      if (exists) {
        this.showToast('Warning', 'Item already added', 'warning')
        return
      }
      this.chosens.push({
        label: item.text,
        value: item.id,
        qty: 1,
      })
    },
    removeRow(val) {
      this.chosens = this.chosens.filter(obj => obj.value !== val)
    },
    handleFilesUpload(e) {
      const [firstFile] = e.target.files
      this.file = firstFile
    },
    submitNewTransfer() {
      if (!this.file) return this.showToast('Required', 'Please upload a document', 'danger')
      if (this.chosens.length === 0) return this.showToast('Required', 'Select at least one item', 'danger')

      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('transfer_notes', this.transferNotes)
      formData.append('branch', this.chosenBranch.value)
      formData.append('type', 'Asset')
      formData.append('transfer_items', JSON.stringify(this.chosens))
      formData.append('time', moment().format())

      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${this.$cookies.get('userToken')}`,
      }

      return axios.post(`${process.env.VUE_APP_API_URL}${apiEndpoints.CREATE_TRANSFER}`, formData, { headers })
        .then(() => {
          this.showToast('Success', 'Transfer created successfully', 'success')
          this.$router.push({ name: 'apps-transfers-list' })
        })
        .catch(() => this.showToast('Error', 'Transfer failed', 'danger'))
    },
    showToast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
        },
      })
    },
  },
}
</script>